import { useState } from "react";
import { useSelector } from "react-redux";
import NotificationDropdown from "./NotificationDropdown";

const DashboardHeader = ({ user, onToggleSidebar, profilePhoto }) => {
  const initials = user?.username ? user.username.charAt(0).toUpperCase() : '';

  return (
    <header className="dashboard-header">
      <div className="d-flex align-items-center justify-content-between p-4 border-bottom">
        <div className="d-flex align-items-center">
        {typeof onToggleSidebar === 'function' && (
          <button
            className="btn d-md-none me-3"
            onClick={onToggleSidebar}
            aria-label="Toggle sidebar"
          >
            <i className="fas fa-bars fs-4"></i>
          </button>
        )}

          <div className="user-avatar me-3">
            <div className="avatar-circle">
            {profilePhoto ? (
              <img
                src={profilePhoto}
                alt="Profile"
                className="avatar-img"
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #e6e6e6",
                  background: "#fff",
                }}
              />
            ) : (
              <div
                className="avatar-circle"
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                  color: "#ffff",
                  fontWeight: 600,
                }}
              >
                {initials}
              </div>
            )}
            </div>
          </div>
          <div className="user-info">
            <div className="greeting text-muted">Hello,</div>
            <div className="user-name">{user.username}</div>
          </div>
        </div>

        <div className="header-actions">
          <NotificationDropdown userId={user?.id || user?.user_id} />
        </div>

      </div>
    </header>
  );
};

export default DashboardHeader;